import React from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';
import { Form, Formik } from 'formik';
import CommonPasswordFields from './CommonPasswordFields';

//TODO check validation
const ChangePasswordAfterResetForm = ({ onSubmit, initialValues }) => (
  <Formik
    enableReinitialize
    initialValues={{
      ...initialValues,
      password: '',
      newPassword: '',
    }}
    onSubmit={onSubmit}
  >
    {({ isSubmitting, dirty, values, handleSubmit }) => (
      <Form onSubmit={handleSubmit}>
        <CommonPasswordFields
          changePassword
          password={values.password}
          repeatPassword={values.newPassword}
        />
        <div>
          <Button
            onClick={handleSubmit}
            type="submit"
            label="Wyślij"
            disabled={isSubmitting || !dirty}
          />
        </div>
      </Form>
    )}
  </Formik>
);

ChangePasswordAfterResetForm.propTypes = {
  onSubmit: PropTypes.func,
  initialValues: PropTypes.object,
};

export default ChangePasswordAfterResetForm;
